import { combineReducers } from "redux";

import AdminReducer from "./AdminReducer";
import ApplicationReducer from "./ApplicationReducer";
import AuthReducer from "./AuthReducer";
import ChatbotReducer from "./ChatbotReducer";
import InternshipsReducer from "./InternshipsReducer";
import OthersReducer from "./OthersReducer";
import MeetingReducer from "./MeetingReducer";
import NotificationsReducer from "./NotificationsReducer";
import ProfileReducer from "./ProfileReducer";
import SchoolReducer from "./SchoolReducer";
import SearchReducer from "./SearchReducer";
import StudentReducer from "./StudentReducer";
import UniversityReducer from "./UniversityReducer";

const RootReducer = combineReducers({
  admin: AdminReducer,
  application: ApplicationReducer,
  auth: AuthReducer,
  chatbot: ChatbotReducer,
  internships: InternshipsReducer,
  others: OthersReducer,
  meeting: MeetingReducer,
  notifications: NotificationsReducer,
  profile: ProfileReducer,
  schools: SchoolReducer,
  search: SearchReducer,
  students: StudentReducer,
  university: UniversityReducer,
});

export default RootReducer;
